import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
        title: '首页',
        requireAuth: false,  // 添加该字段，表示进入这个路由是需要登录的
        showHeader:true,//显示导航栏
        showFooter:true, //显示公共底部
        showBack:false,//显示返回按钮
    },
    component: HomeView,
    
  },
  {
    path: '/tutorialCenter',
    name: 'tutorialCenter',
    meta: {
        title: '教程中心',
        showHeader:true,//显示导航栏
        showFooter:true, //显示公共底部
        showBack:true,//显示返回按钮
    },
    component: () => import('../views/tutorialCenter.vue')
  },
  {
    path: '/deploy',
    name: 'deploy',
    meta: {
        title: '部署与配置',
        showHeader:true,//显示导航栏
        showFooter:true, //显示公共底部
        showBack:true,//显示返回按钮
    },
    component: () => import('../views/deploy.vue')
  },
  {
    path: '/case',
    name: 'case',
    meta: {
        title: '应用案例',
        showHeader:true,//显示导航栏
        showFooter:true, //显示公共底部
        showBack:true,//显示返回按钮
    },
    component: () => import('../views/case.vue')
  },
  {
    path: '/articleDetail',
    name: 'articleDetail',
    meta: {
        title: '详情',
        showHeader:true,//显示导航栏
        showFooter:true, //显示公共底部
        showBack:true,//显示返回按钮
    },
    component: () => import('../views/articleDetail.vue')
  },
  {
    path: '/knowledge',
    name: 'knowledge',
    meta: {
        title: 'IPv6基础知识',
        showHeader:true,//显示导航栏
        showFooter:true, //显示公共底部
        showBack:true,//显示返回按钮
    },
    component: () => import('../views/knowledge.vue')
  },
  {
    path: '/download',
    name: 'download',
    meta: {
        title: '资源下载',
        showHeader:true,//显示导航栏
        showFooter:true, //显示公共底部
        showBack:true,//显示返回按钮
    },
    component: () => import('../views/download.vue')
  },
  
  
  
  
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})

export default router
